import type React from "react";

import { Input as ShadcnInput } from "src/shadcn/components/input";

const Input = (props: React.ComponentProps<typeof ShadcnInput>) => (
  <ShadcnInput {...props} />
);

export { Input };
